<template>
    <div class="qvp-exam-page">
        <div class="page-wrapper">
            <header>
                <div class="logo-area">
                    <img src="/assets/img/QVP NEW LOGO HRIDAYAM.png" alt="QVP Logo" @error="handleImageError">
                </div>
                <h1 class="mal-text">QVP Exam Registration</h1>
                <p class="subtitle mal-text">30-ാമത് ക്വുർആൻ വിജ്ഞാന പരീക്ഷ</p>
                <span class="status-badge mal-text">Registration Open</span>
            </header>
  
            <div class="content-section">
                <div id="alertBox" class="alert-box" :class="alertClass" v-if="alertMessage">
                    {{ alertMessage }}
                </div>
  
                <!-- STEP 1: MOBILE ENTRY -->
                <div id="step-mobile" class="step-container" :class="{ active: currentStep === 'mobile' }">
                    <form @submit.prevent="handleMobileSubmit">
                        <div style="display: flex; gap: 15px;">
                            <div class="form-group" style="flex: 0 0 35%;">
                                <label class="form-label mal-text">Code <span style="color: #dc2626;">*</span></label>
                                <select v-model="mobileCountryCode" class="form-input" required>
                                    <option value="" disabled class="mal-text">Select</option>
                                    <option v-for="code in countryCodeList" :key="code.item_value"
                                        :value="code.item_value">
                                        {{ code.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group" style="flex: 1;">
                                <label class="form-label mal-text">Mobile Number <span
                                        style="color: #dc2626;">*</span></label>
                                <input type="tel" v-model="mobileInput" class="form-input" 
                                    :placeholder="mobileCountryCode === '91' ? '10 Digit Number' : 'Enter Mobile Number'"
                                    :pattern="mobileCountryCode === '91' ? '[0-9]{10}' : '[0-9]{7,15}'" 
                                    :maxlength="mobileCountryCode === '91' ? '10' : '15'" 
                                    inputmode="numeric" required>
                            </div>
                        </div>
                        <button type="submit" class="btn-main mal-text" :disabled="loading">
                            <span class="btn-text" v-if="!loading">Continue</span>
                            <div class="loading-spinner" v-if="loading"></div>
                        </button>
                        <div style="text-align: center; margin-top: 20px;">
                            <span style="font-size: 13px; color: #6b7280;" class="mal-text">
                                തിരിച്ചറിയുന്നതിനായി നിങ്ങളുടെ മൊബൈൽ നമ്പർ നൽകുക (Enter your mobile number)
                            </span>
                        </div>
                        <div style="text-align: center; margin-top: 15px;">
                            <button type="button" class="link-btn mal-text" @click="openInstructionsModal"
                                style="font-size: 14px; color: #006400 !important; text-decoration: underline; cursor: pointer;">
                                📋 പരീക്ഷാ നിർദ്ദേശങ്ങൾ (Exam Instructions)
                            </button>
                        </div>
                    </form>
                </div>
  
                <!-- STEP 2: REGISTRATION FORM -->
                <div id="step-registration" class="step-container" :class="{ active: currentStep === 'registration' }">
                    <div class="active-mobile-card">
                        <span class="number">+{{ mobileCountryCode }} {{ currentMobile }}</span>
                        <button type="button" class="link-btn mal-text" @click="resetFlow">Change</button>
                    </div>
  
                    <form id="regForm" @submit.prevent="handleRegistration">
                        <div class="form-group">
                            <label class="form-label mal-text">Name (പേര്)</label>
                            <input type="text" v-model="formData.name" class="form-input"
                                :placeholder="formData.category === 'kids' ? 'Enter child name' : 'Enter your full name'" required>
                        </div>

                        <!-- Age and Gender - Now before Category -->
                        <div style="display: flex; gap: 15px;">
                            <div class="form-group" style="flex: 1;">
                                <label class="form-label mal-text">Age (പ്രായം) <span style="color: #dc2626;">*</span></label>
                                <input type="number" v-model="formData.age" class="form-input" placeholder="Age" min="5"
                                    max="100" required @input="handleAgeChange">
                            </div>
                            <div class="form-group" style="flex: 1;">
                                <label class="form-label mal-text">Gender <span style="color: #dc2626;">*</span></label>
                                <select v-model="formData.gender" class="form-input" required>
                                    <option value="" disabled class="mal-text">Select</option>
                                    <option value="male" class="mal-text">Male (പുരുഷൻ)</option>
                                    <option value="female" class="mal-text">Female (സ്ത്രീ)</option>
                                </select>
                            </div>
                        </div>

                        <!-- Exam Category Selection - Filtered based on age -->
                        <div class="form-group">
                            <label class="form-label mal-text">Exam Category (പരീക്ഷാ വിഭാഗം)</label>
                            <select v-model="formData.category" class="form-input" required @change="handleCategoryChange"
                                :disabled="!formData.age">
                                <option value="" disabled class="mal-text">
                                    {{ formData.age ? 'Select Category' : 'Please enter age first' }}
                                </option>
                                <option v-for="cat in filteredCategories" :key="cat.id" :value="cat.id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>

                        <!-- Category Description - Shows after category is selected -->
                        <div class="alert-box alert-info mal-text" v-if="formData.category && selectedCategoryDescription"
                            style="margin-top: -15px; margin-bottom: 20px; white-space: pre-line;">
                            {{ selectedCategoryDescription }}
                        </div>

                        <!-- Kids Subcategory Selection -->
                        <div class="form-group" v-if="formData.category === 'kids'">
                            <label class="form-label mal-text">
                                Kids Category <span style="color: #dc2626;">*</span>
                                <span v-if="formData.kids_subcategory" style="color: #28a745; font-size: 12px; margin-left: 8px;">
                                    (Auto-selected)
                                </span>
                            </label>
                            <select v-model="formData.kids_subcategory" class="form-input" required>
                                <option value="" disabled class="mal-text">Select Category</option>
                                <option value="junior" class="mal-text">Junior - Born after 2017</option>
                                <option value="senior" class="mal-text">Senior - Born after 2014</option>
                            </select>
                        </div>

                        <!-- Parent Name (Kids Only) -->
                        <div class="form-group" v-if="formData.category === 'kids'">
                            <label class="form-label mal-text">Parent Name <span style="color: #dc2626;">*</span></label>
                            <input type="text" v-model="formData.parent_name" class="form-input"
                                placeholder="Enter parent name" :required="formData.category === 'kids'">
                        </div>

                        <!-- Parent Mobile (Kids Only) -->
                        <div class="form-group" v-if="formData.category === 'kids'">
                            <label class="form-label mal-text">Parent Mobile Number <span style="color: #dc2626;">*</span></label>
                            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
                                <input type="checkbox" 
                                       v-model="useSameMobileForParent" 
                                       id="same-mobile-checkbox"
                                       @change="handleSameMobileChange"
                                       style="width: 18px; height: 18px; cursor: pointer; accent-color: #1a418c;">
                                <label for="same-mobile-checkbox" class="mal-text" style="cursor: pointer; font-size: 14px; color: #1a418c; margin: 0;">
                                    Use same mobile number ({{ currentMobile ? '+' + mobileCountryCode + ' ' + currentMobile : 'registered number' }})
                                </label>
                            </div>
                                <input type="tel" v-model="formData.parent_mobile" class="form-input"
                                    :placeholder="mobileCountryCode === '91' ? '10 digit mobile number' : 'Enter parent mobile number'" 
                                    :pattern="mobileCountryCode === '91' ? '[0-9]{10}' : '[0-9]{7,15}'" 
                                    :maxlength="mobileCountryCode === '91' ? '10' : '15'" 
                                    inputmode="numeric"
                                    :required="formData.category === 'kids'"
                                    :disabled="useSameMobileForParent">
                        </div>

                        <!-- Campus Category Fields -->
                        <template v-if="formData.category === 'campus'">
                            <div class="form-group">
                                <label class="form-label mal-text">Campus (ക്യാമ്പസ്) <span style="color: #dc2626;">*</span></label>
                                <input type="text" v-model="formData.campus_name" class="form-input"
                                    placeholder="Enter campus name" required>
                            </div>
                            <div class="form-group">
                                <label class="form-label mal-text">Course (കോഴ്‌സ്) <span style="color: #dc2626;">*</span></label>
                                <input type="text" v-model="formData.campus_course" class="form-input"
                                    placeholder="Enter course name" required>
                            </div>
                            <div class="form-group">
                                <label class="form-label mal-text">Year of Studying (പഠന വർഷം) <span style="color: #dc2626;">*</span></label>
                                <select v-model="formData.campus_year" class="form-input" required>
                                    <option value="" disabled class="mal-text">Select Year</option>
                                    <option v-for="y in 6" :key="y" :value="y" class="mal-text">Year {{ y }}</option>
                                </select>
                            </div>
                            <!-- Phone/WhatsApp: user is registering with number shown at top - no separate phone field -->
                            <div class="form-group">
                                <label class="form-label mal-text">WhatsApp Number (വാട്ട്സാപ് നമ്പർ) <span style="color: #dc2626;">*</span></label>
                                <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
                                    <input type="checkbox" 
                                           v-model="useSameMobileForCampusWhatsApp" 
                                           id="same-mobile-campus-whatsapp"
                                           @change="handleSameMobileForCampusWhatsAppChange"
                                           style="width: 18px; height: 18px; cursor: pointer; accent-color: #1a418c;">
                                    <label for="same-mobile-campus-whatsapp" class="mal-text" style="cursor: pointer; font-size: 14px; color: #1a418c; margin: 0;">
                                        Use same mobile number ({{ currentMobile ? '+' + mobileCountryCode + ' ' + currentMobile : 'registered number' }})
                                    </label>
                                </div>
                                <input type="tel" v-model="formData.campus_whatsapp" class="form-input"
                                    :placeholder="mobileCountryCode === '91' ? '10 digit number' : 'Enter WhatsApp number'"
                                    :pattern="mobileCountryCode === '91' ? '[0-9]{10}' : '[0-9]{7,15}'"
                                    :maxlength="mobileCountryCode === '91' ? '10' : '15'"
                                    inputmode="numeric"
                                    :required="!useSameMobileForCampusWhatsApp"
                                    :disabled="useSameMobileForCampusWhatsApp">
                            </div>
                            <div class="form-group">
                                <label class="form-label mal-text">Campus District <span style="color: #dc2626;">*</span></label>
                                <select v-model="formData.campus_district_id" class="form-input" required>
                                    <option value="" disabled class="mal-text">Select Campus District</option>
                                    <option v-for="d in revenueDistricts.filter(d => d.id > 0)" :key="d.id" :value="d.id">
                                        {{ d.name }}
                                    </option>
                                    <option :value="0" class="mal-text">Out of Kerala</option>
                                </select>
                            </div>
                        </template>

                        <!-- Exam Center Section - Hidden for Global and Campus category -->
                        <div v-if="formData.category && formData.category !== 'global' && formData.category !== 'campus'">
                            <!-- <h4 class="form-label mal-text" style="font-size: 16px; margin-bottom: 15px; margin-top: 10px;">
                                പരീക്ഷാ കേന്ദ്രം തിരഞ്ഞെടുക്കുക (Select Your Exam Centre)
                            </h4> -->
  
                        <div class="form-group">
                            <label class="form-label mal-text">District (ജില്ല)</label>
                            <select v-model="selectedRevenueDistrictId" class="form-input" 
                                :required="formData.category !== 'global'"
                                @change="handleRevenueDistrictChange">
                                <option value="" disabled class="mal-text">Select District</option>
                                <option v-for="district in revenueDistricts" :key="district.id" :value="district.id">
                                    {{ district.name }}
                                </option>
                            </select>
                        </div>
  
                        <div class="form-group" v-if="selectedRevenueDistrictId !== 0 && selectedRevenueDistrictId !== '0'">
                            <label class="form-label mal-text">Area (പ്രദേശം)</label>
                            <select v-model="formData.zone_id" class="form-input"
                                :required="formData.category !== 'global'"
                                :disabled="!selectedRevenueDistrictId || zones.length === 0" @change="loadUnits">
                                <option value="" disabled class="mal-text">Select Area</option>
                                <option v-for="zone in zones" :key="zone.id" :value="zone.id">
                                    {{ zone.name }}
                                </option>
                            </select>
                        </div>
  
                        <div id="zoneMessage" class="alert-box alert-info mal-text"
                            v-if="selectedRevenueDistrictId !== 0 && selectedRevenueDistrictId !== '0'"
                            :style="{ display: zones.length > 0 ? 'block' : 'none', marginTop: '-15px', marginBottom: '20px' }">
                            നിങ്ങൾക്ക് ഏറ്റവും അടുത്തുള്ള എക്സാം സെന്റർ ലഭിക്കാൻ കൃത്യമായ പ്രദേശം (Area) സെലക്ട് ചെയ്യുക.
                        </div>
                        </div>
  
                        <div class="form-group" v-if="formData.category !== 'campus' || (formData.category === 'campus' && (formData.campus_district_id === 0 || formData.campus_district_id === '0'))">
                            <label class="form-label mal-text">Place <span v-if="formData.category === 'campus'" style="color: #dc2626;">*</span></label>
                            <input type="text" v-model="formData.place" class="form-input"
                                placeholder="Enter your place"
                                :required="formData.category !== 'campus' || (formData.category === 'campus' && (formData.campus_district_id === 0 || formData.campus_district_id === '0'))">
                        </div>
  
                        <div class="form-group" v-if="formData.category !== 'global' && formData.category !== 'campus'">
                            <label class="form-label mal-text">Pincode</label>
                            <input type="tel" v-model="formData.pincode" class="form-input"
                                placeholder="6 Digit Pincode" pattern="[0-9]{6}" maxlength="6" inputmode="numeric"
                                :required="formData.category !== 'global' && formData.category !== 'campus'">
                        </div>
  
                        <!-- Submit Button -->
                        <button type="submit" class="btn-main mal-text" :disabled="loading" style="margin-top: 15px;">
                            <span class="btn-text" v-if="!loading">Register Now</span>
                            <div class="loading-spinner" v-if="loading"></div>
                        </button>
                    </form>
                </div>
  
                <!-- STEP 3: GUIDE MEMBER MESSAGE -->
                <div id="step-guide" class="step-container" :class="{ active: currentStep === 'guide' }">
                    <div class="guide-box">
                        <div
                            style="background: #ccfbf1; width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 15px;">
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#006400"
                                stroke-width="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                        </div>
                        <h3 style="color: #006400 !important; margin-bottom: 8px; font-size: 20px;" class="mal-text">
                            Guide Member</h3>
                        <p id="guideDetail"
                            style="color: #6b7280; margin-bottom: 25px; line-height: 1.6; font-size: 15px;"
                            class="mal-text">
                            അസ്സലാമു അലൈക്കും, <strong>{{ guideMemberName }}</strong>.<br>
                            നിങ്ങൾ ഒരു ഗൈഡ് മെമ്പർ ആയി രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്. <br>
                            ദയവായി QVP പേജിലേക്ക് മുന്നോട്ട് പോവുക.
                        </p>
  
                        <button class="btn-main mal-text" @click="goToQVPPage"
                            style="text-decoration: none; display: inline-flex;">
                            Go to QVP Page
                        </button>
  
                        <button class="link-btn mal-text" @click="resetFlow"
                            style="margin-top: 25px; display: inline-block;">
                            Change Number
                        </button>
                    </div>
                </div>
  
                <!-- STEP 3.5: LOGIN FORM (for guide members and registered public users) -->
                <div id="step-login" class="step-container" :class="{ active: currentStep === 'login' }">
                    <div class="guide-box">
                        <div
                            style="background: #ccfbf1; width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 15px;">
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#006400"
                                stroke-width="2">
                                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                                <polyline points="10 17 15 12 10 7"></polyline>
                                <line x1="15" y1="12" x2="3" y2="12"></line>
                            </svg>
                        </div>
                        <h3 style="color: #006400 !important; margin-bottom: 8px; font-size: 20px;" class="mal-text">
                            Login Required</h3>
                        <p style="color: #6b7280; margin-bottom: 25px; line-height: 1.6; font-size: 15px;"
                            class="mal-text">
                            {{ shouldShowOTPField ? 'ഗൈഡ് ആപ്പിലേക്ക് തുടരാൻ ലോഗിൻ ചെയ്യുക.' : 'നിങ്ങളുടെ രജിസ്ട്രേഷൻ കാണാൻ ലോഗിൻ ചെയ്യുക.' }}
                        </p>

                        <form @submit.prevent="handleLogin" class="login-form">
                            <div class="form-group">
                                <label class="form-label mal-text">
                                    {{ shouldShowOTPField ? 'PIN / OTP' : 'Password (പാസ്‌വേഡ്)' }}
                                    <span style="color: #dc2626;">*</span>
                                </label>
                                <input 
                                    v-if="shouldShowOTPField"
                                    type="password" 
                                    v-model="loginData.pin" 
                                    class="form-input"
                                    placeholder="Enter PIN / OTP"
                                    maxlength="6"
                                    inputmode="numeric"
                                    pattern="[0-9]{4,6}"
                                    required>
                                <input 
                                    v-else
                                    type="password" 
                                    v-model="loginData.pin" 
                                    class="form-input"
                                    placeholder="Enter your password"
                                    minlength="6"
                                    required>
                            </div>

                            <button type="submit" class="btn-main mal-text" :disabled="loginLoading">
                                <span v-if="!loginLoading">Login</span>
                                <div class="loading-spinner" v-if="loginLoading"></div>
                            </button>

                            <div v-if="shouldShowOTPField" class="pin-forgot-section" style="margin-top: 20px;">
                                <button type="button" class="btn-pin-forgot mal-text" @click="handlePinForgot"
                                    :disabled="pinForgotCountDown > 0 || loginLoading">
                                    <span v-if="pinForgotCountDown === 0">പിൻ അറിയില്ല</span>
                                    <span v-else>പിൻ അറിയില്ല ({{ pinForgotCountDown }}s)</span>
                                </button>
                            </div>

                            <button type="button" class="link-btn mal-text" @click="resetFlow"
                                style="margin-top: 20px; display: inline-block;">
                                Go Back
                            </button>
                        </form>
                    </div>
                </div>
  
                <!-- STEP 4: CREATE ACCOUNT -->
                <div id="step-create-account" class="step-container" :class="{ active: currentStep === 'createAccount' }">
                    <div class="guide-box">
                        <div
                            style="background: #dbeafe; width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 15px;">
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#1d4ed8"
                                stroke-width="2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="8.5" cy="7" r="4"></circle>
                                <line x1="20" y1="8" x2="20" y2="14"></line>
                                <line x1="23" y1="11" x2="17" y2="11"></line>
                            </svg>
                        </div>
                        <h3 style="color: #1d4ed8; margin-bottom: 8px; font-size: 20px;" class="mal-text">
                            Create Account (അക്കൗണ്ട് സൃഷ്ടിക്കുക)</h3>
                        <p style="color: #6b7280; margin-bottom: 25px; line-height: 1.6; font-size: 14px;"
                            class="mal-text">
                            നിങ്ങളുടെ രജിസ്ട്രേഷൻ ട്രാക്ക് ചെയ്യാൻ ഒരു അക്കൗണ്ട് സൃഷ്ടിക്കുക
                        </p>

                        <form @submit.prevent="handleCreateAccount" class="create-account-form">
                            <div class="form-group">
                                <label class="form-label mal-text">Username (യൂസർനെയിം)</label>
                                <input type="text" v-model="accountData.username" class="form-input" 
                                    :placeholder="currentMobile" readonly
                                    style="background: #f3f4f6; cursor: not-allowed;">
                                <p style="font-size: 12px; color: #6b7280; margin-top: 5px; margin-left: 4px;" class="mal-text">
                                    നിങ്ങളുടെ മൊബൈൽ നമ്പർ യൂസർനെയിം ആയി ഉപയോഗിക്കും
                                </p>
                            </div>

                            <div class="form-group">
                                <label class="form-label mal-text">Password (പാസ്‌വേഡ്) <span style="color: #dc2626;">*</span></label>
                                <input type="password" v-model="accountData.password" class="form-input"
                                    placeholder="Enter password (കുറഞ്ഞത് 6 അക്ഷരങ്ങൾ)" minlength="6" required>
                            </div>

                            <div class="form-group">
                                <label class="form-label mal-text">Confirm Password (പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക) <span style="color: #dc2626;">*</span></label>
                                <input type="password" v-model="accountData.confirmPassword" class="form-input"
                                    placeholder="Re-enter password" minlength="6" required>
                            </div>

                            <button type="submit" class="btn-main mal-text" :disabled="accountLoading">
                                <span v-if="!accountLoading">Create Account & Continue</span>
                                <div class="loading-spinner" v-if="accountLoading"></div>
                            </button>

                            <button type="button" class="link-btn mal-text" @click="skipAccountCreation"
                                style="margin-top: 20px; display: inline-block;">
                                Skip for now (ഇപ്പോൾ ഒഴിവാക്കുക)
                            </button>
                        </form>
                    </div>
                </div>

                <!-- STEP 5: SUCCESS MESSAGE -->
                <div id="step-success" class="step-container" :class="{ active: currentStep === 'success' }">
                    <div class="guide-box">
                        <div
                            style="background: #dcfce7; width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 15px;">
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#15803d"
                                stroke-width="2">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <h3 style="color: #15803d; margin-bottom: 12px; font-size: 20px;" class="mal-text">Registration
                            Successful!</h3>
                        <p id="successMessage"
                            style="color: #6b7280; margin-bottom: 25px; line-height: 1.6; font-size: 15px; text-align: center;"
                            class="mal-text">
                            QVP <strong>{{ getCategoryDisplayNameMalayalam(categoryDisplayName) }}</strong> വിഭാഗത്തിൽ
                            നിങ്ങൾ വിജയകരമായി രജിസ്റ്റർ ചെയ്തിരിക്കുന്നു.<br><br>
                            <span v-if="accountCreated">നിങ്ങളുടെ അക്കൗണ്ട് വിജയകരമായി സൃഷ്ടിച്ചു!<br><br></span>
                            എക്സാം അപ്ഡേറ്റുകൾക്കായി താഴെ നൽകിയിട്ടുള്ള ലിങ്കിൽ ക്ലിക്ക് ചെയ്ത് ഞങ്ങളുടെ ഗ്രൂപ്പിൽ ജോയിൻ
                            ചെയ്യുക.
                        </p>

                        <a href="#" id="groupLink" class="btn-main mal-text" target="_blank"
                            style="text-decoration: none; display: inline-flex;">
                            Join Official Group
                        </a>

                        <button class="link-btn mal-text" @click="resetFlow"
                            style="margin-top: 25px; display: inline-block;">
                            Register Another Person
                        </button>
                    </div>
                </div>

                <!-- STEP 6: HOME PAGE (After Login) -->
                <div id="step-home" class="step-container" :class="{ active: currentStep === 'home' }">
                    <div class="active-mobile-card">
                        <span class="number">+{{ mobileCountryCode }} {{ currentMobile }}</span>
                        <button type="button" class="link-btn mal-text" @click="handleLogout">Logout</button>
                    </div>

                    <div class="home-container">
                        <h2 class="mal-text" style="color: #006400; margin-bottom: 20px; text-align: center;">
                            QVP Registration Details
                        </h2>

                        <div v-if="loadingRegistrations" style="text-align: center; padding: 40px;">
                            <div class="loading-spinner" style="margin: 0 auto;"></div>
                            <p class="mal-text" style="margin-top: 15px;">Loading...</p>
                        </div>

                        <div v-else-if="myRegistrations.length > 0">
                            <div v-for="(reg, index) in myRegistrations" :key="reg.id" class="registration-card">
                                <div class="reg-header">
                                    <div class="reg-number">{{ index + 1 }}</div>
                                    <div class="reg-name">{{ reg.name }}</div>
                                </div>
                                <div class="reg-details">
                                    <div class="reg-row">
                                        <span class="reg-label">Age:</span>
                                        <span class="reg-value">{{ reg.age }} years</span>
                                    </div>
                                    <div class="reg-row">
                                        <span class="reg-label">Gender:</span>
                                        <span class="reg-value">{{ reg.gender === 'M' ? 'Male' : 'Female' }}</span>
                                    </div>
                                    <div class="reg-row">
                                        <span class="reg-label">Category:</span>
                                        <span class="reg-value">{{ getCategoryDisplayName(reg.category) }}</span>
                                    </div>
                                    <div class="reg-row">
                                        <span class="reg-label">Mobile:</span>
                                        <span class="reg-value">{{ reg.mobile }}</span>
                                    </div>
                                    <div class="reg-row">
                                        <span class="reg-label">Place:</span>
                                        <span class="reg-value">{{ reg.comments || 'N/A' }}</span>
                                    </div>
                                    <div class="reg-row">
                                        <span class="reg-label">Payment Status:</span>
                                        <span class="reg-value" :class="reg.payment_status === 'Paid' ? 'status-paid' : 'status-pending'">
                                            {{ reg.payment_status }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="alert-box alert-info mal-text" style="margin-top: 20px;">
                                പേയ്മെന്റ് വിവരങ്ങൾ ഉടൻ അപ്ഡേറ്റ് ചെയ്യും
                            </div>
                        </div>

                        <button class="link-btn mal-text" @click="resetFlow"
                            style="margin-top: 25px; display: block; text-align: center;">
                            Register Another Person
                        </button>
                    </div>
                </div>
            </div>
  
            <footer>
                &copy; 2026 | IT Wing Wisdom Islamic Organization.
            </footer>
        </div>
  
        <!-- Instructions Modal -->
        <div id="instructionsModal" class="modal-overlay" :class="{ show: showInstructionsModal }"
            @click="closeInstructionsModal">
            <div class="bottom-modal" @click.stop>
                <div class="modal-header">
                    <h3 class="mal-text">പരീക്ഷാ നിർദ്ദേശങ്ങൾ</h3>
                    <button class="modal-close" @click="closeInstructionsModal">&times;</button>
                </div>
                <div class="modal-content mal-text">
                    <h4>QVP പരീക്ഷാ തീയതി: 2026 മാർച്ച് 8</h4>
                    <p style="margin-bottom: 15px;"><strong>5 വിഭാഗങ്ങൾ</strong></p>
  
                    <h4>1. ജനറൽ (പ്രായ ഭേദമന്യേ)</h4>
                    <p>സൂറ: സജദ, സൂറ: അഹ്സാബ്, സൂറ: സബഅ് - അമാനി മൗലവി തഫ്സീർ</p>
  
                    <h4>2. ടീൻസ് (12 മുതൽ 18 വയസ് വരെ)</h4>
                    <p>സൂറ: ഫാത്വിഹ - പ്രത്യേകം തയ്യാറാക്കിയ മൊഡ്യൂൾ</p>
  
                    <h4>3. കിഡ്സ് (12 വയസ് വരെ)</h4>
                    <ul>
                        <li><strong>കാറ്റഗറി 1 (ജൂനിയർ):</strong> 2017 ന് ശേഷം ജനിച്ചവർ</li>
                        <li><strong>കാറ്റഗറി 2 (സീനിയർ):</strong> 2014 ന് ശേഷം ജനിച്ചവർ</li>
                    </ul>
  
                    <h4>സിലബസ്:</h4>
                    <p><strong>ഫേസ് 1:</strong></p>
                    <ul>
                        <li>സൂറ: അലഖ്</li>
                        <li>റമദാൻ ക്വസ്റ്റ് - റമദാൻ 14 വരെ</li>
                        <li>ഓൺലൈൻ ക്ലാസുകൾ</li>
                    </ul>
  
                    <p><strong>ഫേസ് 2:</strong></p>
                    <ul>
                        <li>സൂറ: അലഖ്</li>
                        <li>സൂറ മുൽക്ക് മനപ്പാഠം</li>
                        <li>Ramadan Quest പുസ്തകം</li>
                    </ul>
  
                    <h4>4. ഗ്ലോബൽ (കേരളത്തിന് പുറത്ത് / ഓൺലൈൻ)</h4>
                    <p>സൂറ: സജദ, സൂറ: അഹ്സാബ്, സൂറ: സബഅ് - അമാനി മൗലവി തഫ്സീർ</p>
                </div>
            </div>
        </div>
  
        <!-- PIN Forgot Modal (Bottom Popup) -->
        <div id="pinForgotModal" class="modal-overlay" :class="{ show: showPinForgotModal }"
            @click="closePinForgotModal">
            <div class="bottom-popup-modal" @click.stop>
                <div class="popup-header">
                    <h3 class="mal-text">PIN അറിയില്ല</h3>
                    <button class="modal-close" @click="closePinForgotModal">&times;</button>
                </div>
                <div class="popup-content">
                    <div v-if="pinForgotCountDown > 0" class="countdown-section">
                        <p class="mal-text" style="text-align: center; margin-bottom: 15px;">
                            OTP അയയ്ക്കുന്നു...
                        </p>
                        <div class="countdown-timer">
                            <svg class="countdown-circle" viewBox="0 0 36 36">
                                <path
                                    class="circle-bg"
                                    d="M18 2.0845
                                       a 15.9155 15.9155 0 0 1 0 31.831
                                       a 15.9155 15.9155 0 0 1 0 -31.831"
                                />
                                <path
                                    class="circle-progress"
                                    :stroke-dasharray="`${(pinForgotCountDown / 15) * 100}, 100`"
                                    d="M18 2.0845
                                       a 15.9155 15.9155 0 0 1 0 31.831
                                       a 15.9155 15.9155 0 0 1 0 -31.831"
                                />
                            </svg>
                            <div class="countdown-text">{{ pinForgotCountDown }}</div>
                        </div>
                        <p class="mal-text" style="text-align: center; margin-top: 15px; font-size: 14px; color: #6b7280;">
                            ദയവായി കാത്തിരിക്കുക...
                        </p>
                    </div>
                    <div v-else class="pin-not-received-section">
                        <p class="mal-text" style="text-align: center; margin-bottom: 20px;">
                            PIN ലഭിച്ചില്ലേ?
                        </p>
                        <a href="https://wa.me/919072660303?text=Hi%2C%20I%20need%20help%20with%20PIN" 
                           target="_blank"
                           class="btn-whatsapp-help mal-text"
                           @click="closePinForgotModal">
                            WhatsApp ഹെൽപ്പ് നമ്പറിലേക്ക് റീഡയറക്ട് ചെയ്യുക
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    import UserService from '../services/user.service';
    import AuthService from '../services/auth.service';
  
    export default {
        name: 'QVPExam',
        data() {
            return {
                currentStep: 'mobile',
                mobileInput: '',
                mobileCountryCode: '91',
                currentMobile: '',
                useSameMobileForParent: false, // Checkbox for using same mobile for parent
                useSameMobileForCampusWhatsApp: false, // Checkbox for campus WhatsApp = same as mobile
                loading: false,
                alertMessage: '',
                alertClass: '',
                showInstructionsModal: false,
                guideMemberName: '',
                categoryDisplayName: '',
                isAddFamilyMode: false, // true when arrived via Add Family Members from /qvp/exam
                revenueDistricts: [], // 14 Kerala districts + Other
                zones: [],
                selectedRevenueDistrictId: '', // Revenue district selection
                examCategories: [
                    {
                        id: 'general',
                        name: 'ജനറൽ (General - പ്രായ ഭേദമന്യേ)',
                        description: 'സൂറ: സജദ, സൂറ: അഹ്സാബ്, സൂറ: സബഅ് - അമാനി മൗലവി തഫ്സീർ'
                    },
                    {
                        id: 'campus',
                        name: 'ക്യാമ്പസ് (Campus - ക്യാമ്പസ് വിദ്യാർത്ഥികൾക്ക്)',
                        description: 'സൂറ: സജദ - അമാനി മൗലവി തഫ്സീർ'
                    },
                    {
                        id: 'teens',
                        name: 'ടീൻസ് (Teens - 12 മുതൽ 18 വയസ് വരെ)',
                        description: 'സൂറ: ഫാത്വിഹ - പ്രത്യേകം തയ്യാറാക്കിയ മൊഡ്യൂൾ'
                    },
                    {
                        id: 'kids',
                        name: 'കിഡ്സ് (Kids - 12 വയസ് വരെ)',
                        description: `Junior - Born in 2017, 2018, 2019
Senior - Born in 2014, 2015, 2016

സിലബസ്:
Phase 1: സൂറ: അലഖ്, റമദാൻ ക്വസ്റ്റ് (റമദാൻ 14 വരെ), ഓൺലൈൻ ക്ലാസുകൾ
Phase 2: സൂറ: അലഖ്, സൂറ മുൽക്ക് മനപ്പാഠം, Ramadan Quest പുസ്തകം`
                    },
                    {
                        id: 'global',
                        name: 'ഗ്ലോബൽ (Global - കേരളത്തിന് പുറത്ത്, ഓൺലൈൻ)',
                        description: 'ഔട്ട് ഓഫ് കേരള പരീക്ഷാർത്ഥികൾക്ക്, ഓൺലൈൻ പരീക്ഷ\nസൂറ: സജദ, സൂറ: അഹ്സാബ്, സൂറ: സബഅ് - അമാനി മൗലവി തഫ്സീർ'
                    }
                ],
                formData: {
                    name: '',
                    age: '',
                    gender: '',
                    district_id: '', // Actual district_id for zones
                    zone_id: '',
                    unit_id: null, // Not used anymore
                    place: '',
                    pincode: '',
                    category: '',
                    kids_subcategory: '', // Junior or Senior (for kids only)
                    parent_name: '', // For kids only
                    parent_mobile: '', // For kids only
                    // Campus category fields
                    campus_name: '',
                    campus_course: '',
                    campus_year: '',
                    campus_phone: '',
                    campus_whatsapp: '',
                    campus_district_id: ''
                },
                API_BASE: 'https://guideportal.wisdomislam.org/api/public/qvp',
                // Login form data
                loginData: {
                    code: '91',
                    mobile: '',
                    pin: ''
                },
                countryCodeList: [],
                loginLoading: false,
                otpCountDown: 0,
                otpSent: false,
                // PIN Forgot functionality
                showPinForgotModal: false,
                pinForgotCountDown: 0,
                pinForgotOtpSent: false,
                // Account creation
                accountData: {
                    username: '',
                    password: '',
                    confirmPassword: ''
                },
                accountLoading: false,
                accountCreated: false,
                // Home page
                myRegistrations: [],
                loadingRegistrations: false,
                isGuideUser: false // Track if current user is a guide member or public user
            };
        },
        computed: {
            selectedCategoryDescription() {
                if (!this.formData.category) return '';
                const cat = this.examCategories.find(c => c.id === this.formData.category);
                return cat ? cat.description : '';
            },
            filteredCategories() {
                if (!this.formData.age || this.formData.age === '') {
                    return [];
                }
                
                const age = parseInt(this.formData.age);
                
                // Age 12: Show both Kids and Teens
                if (age === 12) {
                    return this.examCategories.filter(cat => 
                        cat.id === 'kids' || cat.id === 'teens'
                    );
                }
                // Kids - up to 11 years
                else if (age < 12) {
                    return this.examCategories.filter(cat => cat.id === 'kids');
                }
                // Age 12 to 18: Show Teens, General, Global
                else if (age > 12 && age <= 18) {
                    return this.examCategories.filter(cat => 
                        cat.id === 'teens' || cat.id === 'general' || cat.id === 'global'
                    );
                }
                // 19 years and above - General, Campus, Global (Campus shown for Add Family Members too)
                else {
                    const cats = ['general', 'campus', 'global'];
                    return this.examCategories.filter(cat => cats.includes(cat.id));
                }
            },
            shouldShowOTPField() {
                // First, always check if logged-in user is a guide member (most reliable)
                const user = this.$store.state.auth.user;
                if (user && user.signup_url && user.signup_url !== 'qvp') {
                    return true;
                }
                // If isGuideUser is explicitly set to true, use that
                if (this.isGuideUser === true) {
                    return true;
                }
                // If isGuideUser is explicitly set to false, show password field
                if (this.isGuideUser === false) {
                    return false;
                }
                // If isGuideUser is undefined/null and user is not logged in,
                // we can't determine, so default to password field for safety
                return false;
            }
        },
        mounted() {
            // Close modal on Escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.showInstructionsModal) {
                    this.closeInstructionsModal();
                }
            });
            
            // Check localStorage
            const addFamilyMode = localStorage.getItem('qvp_add_family_mode');
            const storedMobile = localStorage.getItem('qvp_registration_mobile');
            const storedCode = localStorage.getItem('qvp_registration_code');
            const user = this.$store.state.auth.user;
            
            // Pass stored mobile to loadCountryCodes for parsing.
            // Prefer explicit code from storage; if missing, fall back to logged-in user's country_code
            // (important for Add Family flow, to avoid wrong prefix matching like "62xxxx" -> code 62).
            const mobileToProcess = storedMobile;
            const preferredCode = storedCode || (user && user.country_code ? user.country_code.toString() : null);
            this.loadCountryCodes(mobileToProcess, preferredCode);
            
            if (addFamilyMode === 'true' && storedMobile) {
                this.isAddFamilyMode = true;
                // Clear flags
                localStorage.removeItem('qvp_add_family_mode');
                localStorage.removeItem('qvp_registration_mobile');
                localStorage.removeItem('qvp_registration_code');
                
                // Check if user is authenticated
                if (user && user.accessToken) {
                    // User is authenticated, show form directly
                    // parsed mobile and code will be set by loadCountryCodes async
                    this.currentStep = 'registration';
                    // Load revenue districts for the form
                    this.loadDistricts();
                    this.showAlert('രജിസ്ട്രേഷൻ ഫോം പൂരിപ്പിച്ച് കുടുംബാംഗങ്ങളെ ചേർക്കുക', 'success');
                    return; // Skip other checks
                } else {
                    // Not authenticated, show mobile entry and then login
                    return; // Skip other checks
                }
            } else if (storedMobile) {
                // Just mobile stored, pre-fill it
                localStorage.removeItem('qvp_registration_mobile');
                localStorage.removeItem('qvp_registration_code');
            }
            
            // Check if user is already logged in (only if not in Add Family Members mode)
            if (user && user.accessToken) {
                // User is logged in - redirect to QVP exam registration page
                this.$router.push('/qvp/exam');
            }
        },
        methods: {
            getMobileFromUser(user) {
                if (!user) return '';
                
                // Try to get mobile from user object
                if (user.mobile) {
                    return user.mobile;
                }
                
                // Extract mobile from username (username format: country_code + mobile)
                if (user.username) {
                    const username = user.username.toString();
                    const cc = (user.country_code || '').toString();
                    // Remove user's country code from the beginning if present
                    if (cc && username.startsWith(cc) && username.length > cc.length) {
                        return username.substring(cc.length);
                    }
                    // If username is just the mobile number
                    if (username.length === 10) {
                        return username;
                    }
                    // Return last 10 digits
                    return username.slice(-10);
                }
                
                return '';
            },
            handleImageError(event) {
                // Fallback to a default logo if QVP logo is not found
                event.target.src = '/assets/img/logo.png';
            },
            async handleMobileSubmit() {
                const mobile = this.mobileInput.trim();
  
                if (this.mobileCountryCode === '91') {
                    if (mobile.length !== 10) {
                        this.showAlert('ദയവായി സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക', 'error');
                        return;
                    }
                } else {
                    if (mobile.length < 7 || mobile.length > 15) {
                        this.showAlert('Please enter a valid mobile number (7-15 digits)', 'error');
                        return;
                    }
                }
  
                this.loading = true;
                this.hideAlert();
  
                try {
                    const response = await fetch(this.API_BASE + '/check-mobile', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({ 
                            mobile: mobile,
                            code: this.mobileCountryCode
                        })
                    });
  
                    const data = await response.json();
  
                    if (!response.ok) {
                        throw new Error(data.message || 'എന്തോ തെറ്റ് സംഭവിച്ചു');
                    }
  
                    if (data.status === 'guide_member') {
                        // Check if guide user is already logged in
                        const user = this.$store.state.auth.user;
                        if (user && user.accessToken) {
                            // Guide user is already logged in - redirect to QVP exam registration page
                            this.$router.push('/qvp/exam');
                        } else {
                            // Guide user not logged in - show guide member step
                            this.guideMemberName = data.member_name || 'Guide Member';
                            this.isGuideUser = true;
                            this.currentStep = 'guide';
                        }
                    } else if (data.status === 'registered_user') {
                        // User has registration and account
                        const user = this.$store.state.auth.user;
                        
                        // Check if they're a guide member or public user
                        const isGuideMember = this.isGuideUser || // Preserve if already set
                                             data.is_guide_member || 
                                             data.user_type === 'guide' ||
                                             (data.signup_url && data.signup_url !== 'qvp') ||
                                             (user && user.signup_url && user.signup_url !== 'qvp');
                        
                        if (isGuideMember) {
                            // Guide member - check if already logged in
                            if (user && user.accessToken) {
                                // Guide user is already logged in - redirect to QVP exam registration page
                                this.$router.push('/qvp/exam');
                            } else {
                                // Guide user not logged in - show guide member step
                                this.guideMemberName = data.user_name || 'Guide Member';
                                this.isGuideUser = true;
                                this.currentStep = 'guide';
                            }
                        } else {
                            // Public user - always show password field (even if logged in, require re-authentication)
                            this.guideMemberName = data.user_name || 'User';
                            this.loginData.mobile = mobile;
                            this.loginData.code = this.mobileCountryCode;
                            this.isGuideUser = false;
                            this.currentStep = 'login';
                        }
                    } else if (data.status === 'registered_no_account') {
                        // User has registration but no account - show account creation
                        this.guideMemberName = data.user_name || 'User';
                        this.accountData.username = mobile;
                        this.currentMobile = mobile;
                        this.isGuideUser = false;
                        this.currentStep = 'createAccount';
                    } else {
                        // New user - show registration form
                        this.currentMobile = mobile;
                        this.isGuideUser = false;
                        this.currentStep = 'registration';
                        await this.loadDistricts();
                    }
  
                } catch (error) {
                    this.showAlert(error.message || 'എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                } finally {
                    this.loading = false;
                }
            },
            async loadDistricts() {
                try {
                    const response = await fetch(this.API_BASE + '/revenue-districts');
                    const data = await response.json();
  
                    if (data.status === 'success' && data.data) {
                        this.revenueDistricts = data.data; // 14 Kerala districts + Other
                    }
                } catch (error) {
                    console.error('Error loading revenue districts:', error);
                    this.showAlert('ജില്ലകൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി പേജ് റിഫ്രഷ് ചെയ്യുക.', 'error');
                }
            },
            handleAgeChange() {
                // Auto-select category based on age
                if (!this.formData.age || this.formData.age === '') {
                    this.formData.category = '';
                    this.formData.kids_subcategory = '';
                    return;
                }
                
                const age = parseInt(this.formData.age);
                
                // Auto-select category based on age
                if (age === 12) {
                    // Age 12: Auto-select Kids with Senior subcategory
                    this.formData.category = 'kids';
                    this.formData.kids_subcategory = 'senior';
                } else if (age < 12) {
                    // Kids - up to 11 years
                    this.formData.category = 'kids';
                    // Auto-select kids sub-category based on birth year
                    this.formData.kids_subcategory = this.getKidsSubCategory(age);
                } else if (age > 12 && age <= 18) {
                    // Age 12 to 18: Auto-select Teens (but user can change to General or Global)
                    if (!this.formData.category || this.formData.category === 'kids') {
                        this.formData.category = 'teens';
                    }
                    this.formData.kids_subcategory = '';
                } else {
                    // 19 years and above - default to General
                    // User can change to Campus or Global if needed (Campus available in Add Family mode too)
                    if (!this.formData.category || this.formData.category === 'kids' || this.formData.category === 'teens') {
                        this.formData.category = 'general';
                    }
                    this.formData.kids_subcategory = '';
                }
                
                // Trigger category change handler to reset fields if needed
                this.handleCategoryChange();
            },
            getKidsSubCategory(age) {
                // Calculate birth year based on current year (2026)
                const currentYear = 2026;
                const birthYear = currentYear - age;
                
                // Category 1: Junior - Born after 2017 (2018 onwards) = age 0-8 in 2026
                if (birthYear > 2017) {
                    return 'junior';
                }
                // Category 2: Senior - Born 2014-2017 = age 9-12 in 2026
                else if (birthYear >= 2014 && birthYear <= 2017) {
                    return 'senior';
                }
                
                return '';
            },
            handleSameMobileChange() {
                if (this.useSameMobileForParent && this.currentMobile) {
                    // Set parent mobile to current mobile number
                    this.formData.parent_mobile = this.currentMobile;
                } else {
                    // Clear parent mobile when unchecked
                    this.formData.parent_mobile = '';
                }
            },
            handleSameMobileForCampusWhatsAppChange() {
                if (this.useSameMobileForCampusWhatsApp && this.currentMobile) {
                    this.formData.campus_whatsapp = this.currentMobile;
                } else {
                    this.formData.campus_whatsapp = '';
                }
            },
            handleCategoryChange() {
                // If Global category is selected, reset and hide exam center fields
                if (this.formData.category === 'global') {
                    this.selectedRevenueDistrictId = '';
                    this.zones = [];
                    this.formData.district_id = null;
                    this.formData.zone_id = null;
                }
                
                // When switching TO campus: default WhatsApp to same as mobile (user is registering with that number)
                if (this.formData.category === 'campus' && this.currentMobile) {
                    this.useSameMobileForCampusWhatsApp = true;
                    this.formData.campus_whatsapp = this.currentMobile;
                }
                
                // Clear campus fields when switching away from campus
                if (this.formData.category !== 'campus') {
                    this.formData.campus_name = '';
                    this.formData.campus_course = '';
                    this.formData.campus_year = '';
                    this.formData.campus_phone = '';
                    this.formData.campus_whatsapp = '';
                    this.formData.campus_district_id = '';
                    this.useSameMobileForCampusWhatsApp = false;
                }
                
                // Auto-select kids sub-category if category is kids and age is available
                if (this.formData.category === 'kids' && this.formData.age) {
                    const age = parseInt(this.formData.age);
                    this.formData.kids_subcategory = this.getKidsSubCategory(age);
                } else if (this.formData.category !== 'kids') {
                    // Clear kids sub-category and parent fields if category is not kids
                    this.formData.kids_subcategory = '';
                    this.formData.parent_name = '';
                    this.formData.parent_mobile = '';
                    this.useSameMobileForParent = false;
                }
            },
            async handleRevenueDistrictChange() {
                // Reset all
                this.zones = [];
                this.formData.district_id = '';
                this.formData.zone_id = '';
                this.formData.unit_id = null;
  
                if (!this.selectedRevenueDistrictId) return;
  
                // Revenue district IDs: 10=Malappuram, 11=Kozhikode, 0=Other
                const kozhikodeId = '11';
                const malappuramId = '10';
                const otherId = '0';
  
                if (this.selectedRevenueDistrictId == otherId) {
                    // "Other" selected - hide zone/unit, only show place field
                    this.zones = [];
                    this.formData.district_id = null;
                    this.formData.zone_id = null;
                } else if (this.selectedRevenueDistrictId == kozhikodeId || this.selectedRevenueDistrictId == malappuramId) {
                    // For Kozhikode and Malappuram, load zones directly using revenue_district_id
                    await this.loadZonesByRevenueDistrict(this.selectedRevenueDistrictId);
                } else {
                    // For other revenue districts, get the corresponding district_id and load zones
                    await this.loadDistrictByRevenueDistrict(this.selectedRevenueDistrictId);
                }
            },
            async loadDistrictByRevenueDistrict(revenueDistrictId) {
                try {
                    const response = await fetch(this.API_BASE + '/district-by-revenue?revenue_district_id=' + revenueDistrictId);
                    const data = await response.json();
  
                    if (data.status === 'success' && data.data) {
                        // Auto-set the district_id and load zones
                        this.formData.district_id = data.data.id;
                        await this.loadZones(this.formData.district_id);
                    }
                } catch (error) {
                    console.error('Error loading district:', error);
                    this.showAlert('ജില്ല ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                }
            },
            async loadZonesByRevenueDistrict(revenueDistrictId) {
                this.zones = [];
                this.formData.zone_id = '';
                this.formData.unit_id = null;
                this.formData.district_id = null; // No specific district_id for Kozhikode/Malappuram
  
                if (!revenueDistrictId) return;
  
                try {
                    const response = await fetch(this.API_BASE + '/zones?revenue_district_id=' + revenueDistrictId);
                    const data = await response.json();
  
                    if (data.status === 'success' && data.data) {
                        this.zones = data.data;
                    }
                } catch (error) {
                    console.error('Error loading zones:', error);
                    this.showAlert('പ്രദേശങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                }
            },
            async loadZones(districtId) {
                this.zones = [];
                this.formData.zone_id = '';
                this.formData.unit_id = null;
  
                if (!districtId) return;
  
                try {
                    const response = await fetch(this.API_BASE + '/zones?district_id=' + districtId);
                    const data = await response.json();
  
                    if (data.status === 'success' && data.data) {
                        this.zones = data.data;
                    }
                } catch (error) {
                    console.error('Error loading zones:', error);
                    this.showAlert('പ്രദേശങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                }
            },
            async loadUnits() {
                // Units are not used in this form anymore
                this.formData.unit_id = null;
                
                // Set district_id from the selected zone (needed for Kozhikode/Malappuram)
                if (this.formData.zone_id) {
                    const selectedZone = this.zones.find(z => z.id == this.formData.zone_id);
                    if (selectedZone && selectedZone.district_id) {
                        this.formData.district_id = selectedZone.district_id;
                    }
                }
            },
            async handleRegistration() {
                // Validate kids-specific fields
                if (this.formData.category === 'kids') {
                    if (!this.formData.kids_subcategory) {
                        this.showAlert('ദയവായി Kids Category തിരഞ്ഞെടുക്കുക (Junior/Senior)', 'error');
                        return;
                    }
                    if (!this.formData.parent_name) {
                        this.showAlert('ദയവായി Parent Name നൽകുക', 'error');
                        return;
                    }
                    const pMobile = this.formData.parent_mobile;
                    const isValidMobile = this.mobileCountryCode === '91' 
                        ? (pMobile && pMobile.length === 10)
                        : (pMobile && pMobile.length >= 7 && pMobile.length <= 15);

                    if (!isValidMobile) {
                        this.showAlert(this.mobileCountryCode === '91' 
                            ? 'ദയവായി സാധുവായ 10 അക്ക Parent Mobile Number നൽകുക' 
                            : 'Please enter a valid Parent Mobile Number', 'error');
                        return;
                    }
                }

                // Validate campus-specific fields (phone = currentMobile at top, no separate field)
                if (this.formData.category === 'campus') {
                    if (!this.formData.campus_name) {
                        this.showAlert('ദയവായി ക്യാമ്പസ് പേര് നൽകുക', 'error');
                        return;
                    }
                    if (!this.formData.campus_course) {
                        this.showAlert('ദയവായി കോഴ്‌സ് നൽകുക', 'error');
                        return;
                    }
                    if (!this.formData.campus_year) {
                        this.showAlert('ദയവായി പഠന വർഷം തിരഞ്ഞെടുക്കുക', 'error');
                        return;
                    }
                    if (!this.useSameMobileForCampusWhatsApp) {
                        const wa = this.formData.campus_whatsapp;
                        if (!wa || (this.mobileCountryCode === '91' && wa.length !== 10)) {
                            this.showAlert('ദയവായി സാധുവായ വാട്ട്സാപ് നമ്പർ നൽകുക അല്ലെങ്കിൽ സെലക്ട് ചെയ്യുക', 'error');
                            return;
                        }
                    }
                    const isCampusOutOfKerala = this.formData.campus_district_id === 0 || this.formData.campus_district_id === '0';
                    if (isCampusOutOfKerala) {
                        if (!this.formData.place || !this.formData.place.trim()) {
                            this.showAlert('ദയവായി പ്ലേസ് നൽകുക (Out of Kerala)', 'error');
                            return;
                        }
                    } else {
                        if (!this.formData.campus_district_id) {
                            this.showAlert('ദയവായി ജില്ല തിരഞ്ഞെടുക്കുക', 'error');
                            return;
                        }
                    }
                }
                // Validate - for Global category, district/zone not required; for Campus, we resolve from campus_district_id
                // When General/Teens and "Other (Outside Kerala)" selected, zone is not required (only Place)
                else if (this.formData.category !== 'global') {
                    const isOutsideKerala = this.selectedRevenueDistrictId === 0 || this.selectedRevenueDistrictId === '0';
                    if (!isOutsideKerala) {
                        if (!this.formData.district_id) {
                            this.showAlert('ദയവായി ജില്ല തിരഞ്ഞെടുക്കുക', 'error');
                            return;
                        }
                        if (!this.formData.zone_id) {
                            this.showAlert('ദയവായി സോൺ തിരഞ്ഞെടുക്കുക', 'error');
                            return;
                        }
                    }
                }

                this.loading = true;

                // For campus, resolve district_id and zone_id from campus_district_id before submit (skip when Out of Kerala)
                let districtIdForSubmit = this.formData.district_id;
                let zoneIdForSubmit = this.formData.zone_id;
                const isCampusOutOfKerala = this.formData.category === 'campus' && (this.formData.campus_district_id === 0 || this.formData.campus_district_id === '0');
                if (this.formData.category === 'campus' && this.formData.campus_district_id && !isCampusOutOfKerala) {
                    try {
                        const distResp = await fetch(this.API_BASE + '/district-by-revenue?revenue_district_id=' + this.formData.campus_district_id);
                        const distData = await distResp.json();
                        if (distData.status === 'success' && distData.data) {
                            districtIdForSubmit = distData.data.id;
                            const zoneResp = await fetch(this.API_BASE + '/zones?revenue_district_id=' + this.formData.campus_district_id);
                            const zoneData = await zoneResp.json();
                            if (zoneData.status === 'success' && zoneData.data && zoneData.data.length > 0) {
                                zoneIdForSubmit = zoneData.data[0].id;
                            }
                        }
                    } catch (e) {
                        console.error('Campus district resolution failed:', e);
                        this.showAlert('ജില്ല വിവരങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                        this.loading = false;
                        return;
                    }
                }

                // Prepare member data
                const memberData = {
                    mobile: this.currentMobile,
                    name: this.formData.name,
                    age: this.formData.age,
                    gender: this.formData.gender,
                    district_id: districtIdForSubmit,
                    zone_id: zoneIdForSubmit,
                    unit_id: this.formData.unit_id,
                    place: (this.formData.category === 'campus' && !isCampusOutOfKerala) ? '' : (this.formData.place || ''),
                    pincode: this.formData.category === 'campus' ? '' : this.formData.pincode,
                    category: this.formData.category
                };

                // Add kids-specific fields if applicable
                if (this.formData.category === 'kids') {
                    memberData.kids_subcategory = this.formData.kids_subcategory;
                    memberData.parent_name = this.formData.parent_name;
                    memberData.parent_mobile = this.formData.parent_mobile;
                }
                // Add campus-specific fields if applicable (phone = currentMobile, whatsapp = same or manual)
                if (this.formData.category === 'campus') {
                    memberData.campus_name = this.formData.campus_name;
                    memberData.campus_course = this.formData.campus_course;
                    memberData.campus_year = this.formData.campus_year;
                    memberData.campus_phone = this.currentMobile; // Same as registered number
                    memberData.campus_whatsapp = this.useSameMobileForCampusWhatsApp ? this.currentMobile : this.formData.campus_whatsapp;
                    if (isCampusOutOfKerala) {
                        memberData.campus_district_name = 'Out of Kerala';
                    } else {
                        const campusDistrict = this.revenueDistricts.find(d => d.id == this.formData.campus_district_id);
                        memberData.campus_district_name = campusDistrict ? campusDistrict.name : '';
                    }
                }

                const registrationData = {
                    mobile: this.currentMobile,
                    country_code: this.mobileCountryCode || '91',
                    members: [memberData]
                };

                try {
                    const response = await fetch(this.API_BASE + '/register', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify(registrationData)
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        throw new Error(data.message || 'രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു');
                    }

                    // Success - Check if user is already authenticated
                    const user = this.$store.state.auth.user;
                    if (user && user.accessToken) {
                        // User is authenticated - redirect to /qvp/exam
                        this.showAlert('രജിസ്ട്രേഷൻ വിജയകരം!', 'success');
                        this.loading = false;
                        
                        // Wait a moment for the alert to be visible, then redirect
                        setTimeout(() => {
                            this.$router.push('/qvp/exam');
                        }, 1000);
                    } else {
                        // Not authenticated - Show account creation step
                        this.categoryDisplayName = this.getCategoryDisplayName(this.formData.category);
                        this.accountData.username = this.currentMobile; // Set username to mobile number
                        this.currentStep = 'createAccount';
                        this.loading = false;
                    }

                } catch (error) {
                    this.showAlert(error.message || 'രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                    this.loading = false;
                }
            },
            async handleCreateAccount() {
                // Validate passwords
                if (!this.accountData.password || this.accountData.password.length < 6) {
                    this.showAlert('പാസ്‌വേഡ് കുറഞ്ഞത് 6 അക്ഷരങ്ങൾ ഉണ്ടായിരിക്കണം', 'error');
                    return;
                }

                if (this.accountData.password !== this.accountData.confirmPassword) {
                    this.showAlert('പാസ്‌വേഡുകൾ പൊരുത്തപ്പെടുന്നില്ല. ദയവായി വീണ്ടും പരിശോധിക്കുക.', 'error');
                    return;
                }

                this.accountLoading = true;
                this.hideAlert();

                try {
                    const response = await fetch(this.API_BASE + '/create-account', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            mobile: this.currentMobile,
                            code: this.mobileCountryCode || '91',
                            username: this.accountData.username,
                            password: this.accountData.password,
                            password_confirmation: this.accountData.confirmPassword
                        })
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        throw new Error(data.message || 'അക്കൗണ്ട് സൃഷ്ടിക്കുന്നതിൽ പരാജയം');
                    }

                    // Success
                    this.accountCreated = true;
                    
                    // Login user automatically after account creation
                    try {
                        const loginUser = {
                            code: this.mobileCountryCode || '91',
                            mobile: this.currentMobile,
                            pin: this.accountData.password,
                            signin_url: 'qvp'
                        };
                        loginUser.username = loginUser.code + loginUser.mobile;
                        loginUser.fcm = localStorage.getItem('fcm') || '';
                        
                        await this.$store.dispatch('auth/userLogin', loginUser);
                        
                        // Redirect to QVP exam page
                        this.$router.push('/qvp/exam');
                    } catch (loginError) {
                        // If auto-login fails, show success and let user login manually
                        this.currentStep = 'success';
                    }

                } catch (error) {
                    this.showAlert(error.message || 'അക്കൗണ്ട് സൃഷ്ടിക്കുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                } finally {
                    this.accountLoading = false;
                }
            },
            skipAccountCreation() {
                // Skip account creation and go directly to success
                this.accountCreated = false;
                this.currentStep = 'success';
            },
            async loadMyRegistrations() {
                this.loadingRegistrations = true;
                try {
                    const response = await fetch(this.API_BASE + '/my-registration', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            mobile: this.currentMobile,
                            code: this.mobileCountryCode || '91'
                        })
                    });

                    const data = await response.json();

                    if (response.ok && data.status === 'success') {
                        this.myRegistrations = data.data;
                    } else {
                        this.myRegistrations = [];
                    }
                } catch (error) {
                    console.error('Error loading registrations:', error);
                    this.myRegistrations = [];
                } finally {
                    this.loadingRegistrations = false;
                }
            },
            handleLogout() {
                // Reset and go back to mobile entry
                this.resetFlow();
            },
            getCategoryDisplayName(categoryValue) {
                const categoryMap = {
                    'kids': 'Kids',
                    'teens': 'Teens',
                    'adults': 'Adults',
                    'seniors': 'Seniors'
                };
                return categoryMap[categoryValue] || categoryValue;
            },
            getCategoryDisplayNameMalayalam(categoryValue) {
                const categoryMap = {
                    'kids': 'കിഡ്സ്',
                    'teens': 'ടീൻസ്',
                    'adults': 'അഡൾട്ട്സ്',
                    'seniors': 'സീനിയർസ്',
                    'Kids': 'കിഡ്സ്',
                    'Teens': 'ടീൻസ്',
                    'Adults': 'അഡൾട്ട്സ്',
                    'Seniors': 'സീനിയർസ്'
                };
                return categoryMap[categoryValue] || categoryValue;
            },
            goToQVPPage() {
                // Check if user is logged in
                const user = this.$store.state.auth.user;
                if (!user || !user.accessToken) {
                    // Show login form on the same page
                    // Pre-fill mobile number and country code from landing page
                    if (this.mobileInput) {
                        this.loginData.mobile = this.mobileInput;
                    }
                    if (this.mobileCountryCode) {
                        this.loginData.code = this.mobileCountryCode;
                    }
                    this.isGuideUser = true; // Guide members use PIN/OTP
                    this.currentStep = 'login';
                } else {
                    // User is logged in, redirect to QVP exam registration page
                    this.$router.push('/qvp/exam');
                }
            },
            backToGuideStep() {
                this.currentStep = 'guide';
                this.loginData.pin = '';
            },
            async handleLogin() {
                if (!this.loginData.code || !this.loginData.mobile || !this.loginData.pin) {
                    this.showAlert('ദയവായി എല്ലാ ഫീൽഡുകളും പൂരിപ്പിക്കുക', 'error');
                    return;
                }

                if (this.loginData.code === '91') {
                    if (this.loginData.mobile.length !== 10) {
                        this.showAlert('ദയവായി സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക', 'error');
                        return;
                    }
                } else {
                    if (this.loginData.mobile.length < 7 || this.loginData.mobile.length > 15) {
                        this.showAlert('Please enter a valid mobile number', 'error');
                        return;
                    }
                }

                if (!this.loginData.pin || this.loginData.pin.length < 4) {
                    this.showAlert('ദയവായി സാധുവായ PIN/OTP (4-6 അക്കങ്ങൾ) നൽകുക', 'error');
                    return;
                }

                this.loginLoading = true;
                this.hideAlert();

                try {
                    const loginUser = {
                        code: this.loginData.code,
                        mobile: this.loginData.mobile,
                        pin: this.loginData.pin,
                        signin_url: 'qvp' // Track that user logged in via QVP
                    };

                    // Construct username from code + mobile (same as Login.vue)
                    loginUser.username = loginUser.code + loginUser.mobile;
                    loginUser.fcm = localStorage.getItem('fcm') || '';

                    await this.$store.dispatch('auth/userLogin', loginUser);

                    // Check if user came from "Add Family Members" button
                    const addFamilyMode = localStorage.getItem('qvp_add_family_mode');
                    
                    if (addFamilyMode === 'true') {
                        // Clear the flag
                        localStorage.removeItem('qvp_add_family_mode');
                        
                        // Stay on this page and show registration form
                        this.loginLoading = false;
                        this.currentStep = 'registration';
                        this.loadDistricts();
                        this.showAlert('രജിസ്ട്രേഷൻ ഫോം പൂരിപ്പിച്ച് കുടുംബാംഗങ്ങളെ ചേർക്കുക', 'success');
                    } else {
                        // All users (public and guide) - redirect to QVP exam registration page
                        this.loginLoading = false;
                        this.$router.push('/qvp/exam');
                    }
                    
                } catch (error) {
                    this.loginLoading = false;
                    let errorMessage = 'ലോഗിൻ പരാജയപ്പെട്ടു. ദയവായി നിങ്ങളുടെ ക്രെഡൻഷ്യലുകൾ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.';

                    if (error.response) {
                        if (error.response.status === 422) {
                            errorMessage = (error.response.data && error.response.data.message) ||
                                'സാധുവല്ലാത്ത ക്രെഡൻഷ്യലുകൾ. ദയവായി നിങ്ങളുടെ മൊബൈൽ നമ്പറും PIN/OTP-യും പരിശോധിക്കുക.';
                        } else if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error.message) {
                        errorMessage = error.message;
                    }

                    this.showAlert(errorMessage, 'error');
                }
            },
            loadCountryCodes(mobileToParse = null, preferredCode = null) {
                const data = {
                    code: 'COUNTRY_CODE',
                    type_id: null
                };
                UserService.getCombobox(data).then(
                    (response) => {
                        this.countryCodeList = response.data.data.list.options || [];
                        
                        let codeFound = false;

                        // If we have explicit code + stored mobile, set it directly (no guessing)
                        if (preferredCode && mobileToParse) {
                            const asString = mobileToParse.toString();
                            if (asString.startsWith(preferredCode)) {
                                this.mobileCountryCode = preferredCode;
                                this.currentMobile = asString.substring(preferredCode.length);
                            } else {
                                // In case storedMobile was saved without prefix (older values)
                                this.mobileCountryCode = preferredCode;
                                this.currentMobile = asString;
                            }
                            this.mobileInput = this.currentMobile;
                            this.loginData.code = this.mobileCountryCode;
                            codeFound = true;
                        }

                        // Only guess by prefix if we did NOT already set code explicitly
                        if (!codeFound && mobileToParse) {
                             // Sort by length desc to match longest code first
                             const sortedCodes = [...this.countryCodeList].sort((a,b) => b.item_value.length - a.item_value.length);
                             
                             for (const code of sortedCodes) {
                                 if (mobileToParse.startsWith(code.item_value)) {
                                     this.mobileCountryCode = code.item_value;
                                     this.currentMobile = mobileToParse.substring(code.item_value.length);
                                     this.mobileInput = this.currentMobile;
                                     this.loginData.code = code.item_value;
                                     codeFound = true;
                                     break;
                                 }
                             }
                        }

                        if (!codeFound) {
                            // Set default to India (91)
                            if (this.countryCodeList.length > 0) {
                                const indiaCode = this.countryCodeList.find(code => code.item_value === '91');
                                if (indiaCode) {
                                    this.mobileCountryCode = '91';
                                    this.loginData.code = '91';
                                }
                            }
                            // If provided mobile didn't match any code, use as is (likely 91 without code or unknown)
                            if (mobileToParse) {
                                this.mobileInput = mobileToParse;
                                this.currentMobile = mobileToParse;
                            }
                        }
                    },
                    (error) => {
                        console.error('Error loading country codes:', error);
                        // Set default country code list with India
                        this.countryCodeList = [{ item_value: '91', name: '+91 India' }];
                        this.mobileCountryCode = '91';
                        if (mobileToParse) {
                            this.mobileInput = mobileToParse;
                            this.currentMobile = mobileToParse;
                        }
                    }
                );
            },
            sendOtp() {
                if (!this.loginData.code || !this.loginData.mobile) {
                    this.showAlert('ദയവായി കൺട്രി കോഡും മൊബൈൽ നമ്പറും നൽകുക', 'error');
                    return;
                }
  
                if (this.loginData.code === '91') {
                    if (this.loginData.mobile.length !== 10) {
                        this.showAlert('ദയവായി സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക', 'error');
                        return;
                    }
                } else {
                    if (this.loginData.mobile.length < 7 || this.loginData.mobile.length > 15) {
                        this.showAlert('Please enter a valid mobile number', 'error');
                        return;
                    }
                }
  
                if (this.otpCountDown > 0) {
                    return; // Already counting down
                }
  
                this.loginLoading = true;
                this.hideAlert();
  
                const data = {
                    code: this.loginData.code,
                    mobile: this.loginData.mobile
                };
  
                AuthService.getOtp(data).then(
                    (response) => {
                        this.loginLoading = false;
                        if (response.data.status === 'success') {
                            this.otpCountDown = 30;
                            this.otpSent = true;
                            this.countDownTimer();
                            this.showAlert(response.data.message || 'SMS/WhatsApp വഴി OTP വിജയകരമായി അയച്ചു', 'success');
                        } else if (response.data.status === 'warning') {
                            this.showAlert(response.data.message || 'മുന്നറിയിപ്പ്: ദയവായി നിങ്ങളുടെ മൊബൈൽ നമ്പർ പരിശോധിക്കുക', 'error');
                        } else {
                            this.showAlert(response.data.message || 'OTP അയയ്ക്കുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                        }
                    },
                    (error) => {
                        this.loginLoading = false;
                        let errorMessage = 'OTP അയയ്ക്കുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.';
  
                        if (error.response && error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.message) {
                            errorMessage = error.message;
                        }
  
                        // If error suggests WhatsApp, show appropriate message
                        if (errorMessage.toLowerCase().includes('whatsapp') || errorMessage.toLowerCase().includes('wa.me')) {
                            this.showAlert('ദയവായി WhatsApp വഴി സപ്പോർട്ടുമായി ബന്ധപ്പെടുക: https://wa.me/919072660303', 'error');
                        } else {
                            this.showAlert(errorMessage, 'error');
                        }
                    }
                );
            },
            countDownTimer() {
                if (this.otpCountDown > 0) {
                    setTimeout(() => {
                        this.otpCountDown--;
                        if (this.otpCountDown > 0) {
                            this.countDownTimer();
                        } else {
                            this.otpSent = false;
                        }
                    }, 1000);
                }
            },
            handlePinForgot() {
                if (!this.loginData.code || !this.loginData.mobile) {
                    this.showAlert('ദയവായി കൺട്രി കോഡും മൊബൈൽ നമ്പറും നൽകുക', 'error');
                    return;
                }
  
                if (this.loginData.code === '91') {
                    if (this.loginData.mobile.length !== 10) {
                        this.showAlert('ദയവായി സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക', 'error');
                        return;
                    }
                } else {
                    if (this.loginData.mobile.length < 7 || this.loginData.mobile.length > 15) {
                        this.showAlert('Please enter a valid mobile number', 'error');
                        return;
                    }
                }
  
                if (this.pinForgotCountDown > 0) {
                    return; // Already counting down
                }
  
                this.loginLoading = true;
                this.hideAlert();
  
                const data = {
                    code: this.loginData.code,
                    mobile: this.loginData.mobile
                };
  
                AuthService.getOtp(data).then(
                    (response) => {
                        this.loginLoading = false;
                        if (response.data.status === 'success') {
                            // Start countdown and show modal
                            this.pinForgotCountDown = 15;
                            this.pinForgotOtpSent = true;
                            this.showPinForgotModal = true;
                            document.body.style.overflow = 'hidden';
                            this.pinForgotCountDownTimer();
                            this.showAlert(response.data.message || 'SMS/WhatsApp വഴി OTP വിജയകരമായി അയച്ചു', 'success');
                        } else if (response.data.status === 'warning') {
                            this.showAlert(response.data.message || 'മുന്നറിയിപ്പ്: ദയവായി നിങ്ങളുടെ മൊബൈൽ നമ്പർ പരിശോധിക്കുക', 'error');
                        } else {
                            this.showAlert(response.data.message || 'OTP അയയ്ക്കുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
                        }
                    },
                    (error) => {
                        this.loginLoading = false;
                        let errorMessage = 'OTP അയയ്ക്കുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.';
  
                        if (error.response && error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.message) {
                            errorMessage = error.message;
                        }
  
                        // If error suggests WhatsApp, show appropriate message
                        if (errorMessage.toLowerCase().includes('whatsapp') || errorMessage.toLowerCase().includes('wa.me')) {
                            this.showAlert('ദയവായി WhatsApp വഴി സപ്പോർട്ടുമായി ബന്ധപ്പെടുക: https://wa.me/919072660303', 'error');
                        } else {
                            this.showAlert(errorMessage, 'error');
                        }
                    }
                );
            },
            pinForgotCountDownTimer() {
                if (this.pinForgotCountDown > 0) {
                    setTimeout(() => {
                        this.pinForgotCountDown--;
                        if (this.pinForgotCountDown > 0) {
                            this.pinForgotCountDownTimer();
                        } else {
                            this.pinForgotOtpSent = false;
                        }
                    }, 1000);
                }
            },
            closePinForgotModal() {
                this.showPinForgotModal = false;
                document.body.style.overflow = '';
            },
            resetFlow() {
                this.mobileInput = '';
                this.mobileCountryCode = '91';
                this.currentMobile = '';
                this.currentStep = 'mobile';
                this.hideAlert();
                this.isGuideUser = false;
                // Reset login data
                this.loginData = {
                    code: '91',
                    mobile: '',
                    pin: ''
                };
                this.formData = {
                    name: '',
                    age: '',
                    gender: '',
                    district_id: '',
                    zone_id: '',
                    unit_id: null,
                    place: '',
                    pincode: '',
                    category: '',
                    kids_subcategory: '',
                    parent_name: '',
                    parent_mobile: ''
                };
                this.useSameMobileForParent = false; // Reset checkbox
                this.selectedRevenueDistrictId = '';
                this.revenueDistricts = [];
                this.zones = [];
                // Reset PIN forgot state
                this.showPinForgotModal = false;
                this.pinForgotCountDown = 0;
                this.pinForgotOtpSent = false;
                // Reset account data
                this.accountData = {
                    username: '',
                    password: '',
                    confirmPassword: ''
                };
                this.accountCreated = false;
                this.myRegistrations = [];
            },
            showAlert(msg, type) {
                this.alertMessage = msg;
                this.alertClass = type === 'error' ? 'alert-error' : 'alert-success';
            },
            hideAlert() {
                this.alertMessage = '';
                this.alertClass = '';
            },
            openInstructionsModal() {
                this.showInstructionsModal = true;
                document.body.style.overflow = 'hidden';
            },
            closeInstructionsModal(event) {
                if (event && event.target !== event.currentTarget) {
                    return;
                }
                this.showInstructionsModal = false;
                document.body.style.overflow = '';
            }
        }
    };
  </script>
  
  <style>
    /* Override appCapsule padding for QVP page */
    #appCapsule.qvp-page {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        background: #ffffff !important;
    }
  
    body:has(#appCapsule.qvp-page) {
        background: #ffffff !important;
    }
  </style>
  
  <style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');
  
    .qvp-exam-page {
        --primary: #006400;
        --primary-light: #228b22;
        --accent: #d4af37;
        --bg-color: #ffffff;
        --input-bg: #f8fcfb;
        --text-main: #1f2937;
        --text-light: #6b7280;
  
        font-family: 'Outfit', sans-serif;
        background: var(--bg-color);
        color: var(--text-main);
        line-height: 1.5;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        padding: 0 !important;
        margin: 0 !important;
        position: relative;
    }
  
  
    /* Layout Container for centering content on larger screens */
    .page-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        padding: 0 20px 5px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
  
    /* Header */
    header {
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
    }
  
    .logo-area {
        width: 120px;
        height: auto;
        margin: 0 auto 20px;
    }
  
    .logo-area img {
        width: 100%;
        height: auto;
        display: block;
    }
  
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #006400 !important;
        letter-spacing: -0.5px;
        margin-bottom: 6px;
    }
  
    .subtitle {
        font-size: 16px;
        color: var(--text-light);
        font-weight: 400;
    }
  
    .status-badge {
        display: inline-block;
        background: #fff8e1;
        color: #b8860b;
        padding: 4px 12px;
        border-radius: 100px;
        font-size: 13px;
        font-weight: 600;
        margin-top: 12px;
    }
  
    /* Forms & Interactive Areas */
    .content-section {
        width: 100%;
    }
  
    .form-group {
        margin-bottom: 24px;
    }
  
    .form-label {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #006400 !important;
        margin-left: 4px;
    }
  
    .form-input {
        width: 100%;
        padding: 18px 20px;
        background: var(--input-bg);
        border: none;
        border-radius: 16px;
        font-size: 17px;
        font-family: inherit;
        color: var(--text-main);
        transition: all 0.2s ease;
    }
  
    .form-input:focus {
        outline: none;
        background: #fff;
        border-color: #006400 !important;
        box-shadow: 0 0 0 4px rgba(0, 100, 0, 0.05) !important;
    }
  
    .form-input::placeholder {
        color: #9ca3af;
    }
  
    /* Full Width Button */
    .btn-main {
        width: 100%;
        padding: 20px;
        background: #006400 !important;
        color: #fff !important;
        border: none;
        border-radius: 16px;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.5px;
        cursor: pointer;
        transition: transform 0.2s, background 0.2s;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
    }
  
    .btn-main:active {
        transform: scale(0.98);
    }
  
    .btn-main:disabled {
        background: #9ca3af;
        cursor: not-allowed;
        transform: none;
    }
  
    /* Steps Management */
    .step-container {
        display: none;
        opacity: 0;
        animation: fadeIn 0.5s forwards;
    }
  
    .step-container.active {
        display: block;
    }
  
    /* Login Form Styles */
    .login-form {
        width: 100%;
    }

    .login-form .form-group {
        margin-bottom: 20px;
    }

    /* Create Account Form Styles */
    .create-account-form {
        width: 100%;
        text-align: left;
    }

    .create-account-form .form-group {
        margin-bottom: 20px;
    }
  
    .otp-section {
        width: 100%;
    }
  
    .btn-otp {
        width: 100%;
        padding: 16px;
        background: #0ea5e9 !important;
        color: #fff !important;
        border: none;
        border-radius: 12px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        justify-content: center;
        align-items: center;
    }
  
    .btn-otp:hover:not(:disabled) {
        background: #0284c7 !important;
        transform: scale(0.98);
    }
  
    .btn-otp:disabled {
        background: #9ca3af !important;
        cursor: not-allowed;
        opacity: 0.7;
    }
  
    .whatsapp-support {
        width: 100%;
    }
  
    .btn-whatsapp {
        width: 100%;
        padding: 14px;
        background: #25d366 !important;
        color: #fff !important;
        border: none;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        display: block;
        text-align: center;
        transition: all 0.2s;
    }
  
    .btn-whatsapp:hover {
        background: #20ba5a !important;
        transform: scale(0.98);
    }
  
    .mobile-display {
        padding: 12px 15px;
        background: #f3f4f6;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
    }
  
    .mobile-text {
        font-size: 16px;
        color: #1f2937;
        font-weight: 500;
    }
  
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
  
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
  
    /* Mobile change indicator */
    .active-mobile-card {
        background: #f0fdf9;
        border: none;
        padding: 15px;
        border-radius: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;
    }
  
    .active-mobile-card .number {
        font-weight: 600;
        color: #006400 !important;
        font-size: 16px;
    }
  
    .link-btn {
        background: none;
        border: none;
        color: #228b22 !important;
        text-decoration: underline;
        font-weight: 500;
        cursor: pointer;
        font-size: 14px;
    }
  
    /* Guide Info Box */
    .guide-box {
        background: #f0fdfa;
        padding: 30px 20px;
        border-radius: 20px;
        text-align: center;
        margin-top: 10px;
    }
  
    /* Footer */
    footer {
        text-align: center;
        padding: 8px 20px;
        font-size: 12px;
        color: #9ca3af;
        margin-top: auto;
        margin-bottom: 0;
        padding-bottom: env(safe-area-inset-bottom, 8px);
    }
  
    /* Utilities */
    .loading-spinner {
        width: 20px;
        height: 20px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }
  
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
  
    .alert-box {
        padding: 15px;
        border-radius: 12px;
        margin-bottom: 25px;
        font-size: 14px;
        text-align: center;
        font-weight: 500;
    }
  
    .alert-error {
        background: #fee2e2;
        color: #b91c1c;
    }
  
    .alert-success {
        background: #dcfce7;
        color: #15803d;
    }
  
    .alert-info {
        background: #e0f2fe;
        color: #0369a1;
        text-align: left;
        font-size: 13px;
        line-height: 1.6;
    }
  
    /* Bottom Modal Styles */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: none;
        animation: fadeIn 0.3s ease;
    }
  
    .modal-overlay.show {
        display: flex;
        align-items: flex-end;
    }
  
    .bottom-modal {
        background: #fff;
        width: 100%;
        max-height: 85vh;
        border-radius: 20px 20px 0 0;
        padding: 25px 20px;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
        overflow-y: auto;
        animation: slideUp 0.3s ease;
        max-width: 500px;
        margin: 0 auto;
        border: none;
    }
  
    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }
  
        to {
            transform: translateY(0);
        }
    }
  
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 0;
        border-bottom: none;
    }
  
    .modal-header h3 {
        font-size: 20px;
        font-weight: 700;
        color: var(--primary);
        margin: 0;
    }
  
    .modal-close {
        background: none;
        border: none;
        font-size: 24px;
        color: #6b7280;
        cursor: pointer;
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background 0.2s;
    }
  
    .modal-close:hover {
        background: #f3f4f6;
    }
  
    .modal-content {
        color: var(--text-main);
        line-height: 1.8;
        font-size: 14px;
        border: none;
    }
  
    .modal-content h4 {
        color: var(--primary);
        font-size: 16px;
        font-weight: 600;
        margin-top: 20px;
        margin-bottom: 10px;
        border: none;
    }
  
    .modal-content h4:first-child {
        margin-top: 0;
    }
  
    .modal-content ul {
        margin: 10px 0;
        padding-left: 20px;
    }
  
    .modal-content li {
        margin-bottom: 8px;
    }
  
    .modal-content strong {
        color: var(--primary);
        font-weight: 600;
    }
  
    /* PIN Forgot Button Styles */
    .pin-forgot-section {
        width: 100%;
    }
  
    .btn-pin-forgot {
        width: 100%;
        padding: 16px;
        background: #f59e0b !important;
        color: #fff !important;
        border: none;
        border-radius: 12px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        justify-content: center;
        align-items: center;
    }
  
    .btn-pin-forgot:hover:not(:disabled) {
        background: #d97706 !important;
        transform: scale(0.98);
    }
  
    .btn-pin-forgot:disabled {
        background: #9ca3af !important;
        cursor: not-allowed;
        opacity: 0.7;
    }
  
    /* Bottom Popup Modal for PIN Forgot */
    .bottom-popup-modal {
        background: #fff;
        width: 100%;
        max-width: 500px;
        border-radius: 20px 20px 0 0;
        padding: 25px 20px 35px;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
        animation: slideUp 0.3s ease;
        margin: 0 auto;
    }
  
    .popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e5e7eb;
    }
  
    .popup-header h3 {
        font-size: 20px;
        font-weight: 700;
        color: #006400 !important;
        margin: 0;
    }
  
    .popup-content {
        text-align: center;
    }
  
    /* Countdown Section */
    .countdown-section {
        padding: 20px 0;
    }
  
    .countdown-timer {
        position: relative;
        width: 120px;
        height: 120px;
        margin: 20px auto;
    }
  
    .countdown-circle {
        width: 100%;
        height: 100%;
        transform: rotate(-90deg);
    }
  
    .circle-bg {
        fill: none;
        stroke: #e5e7eb;
        stroke-width: 3;
    }
  
    .circle-progress {
        fill: none;
        stroke: #f59e0b;
        stroke-width: 3;
        stroke-linecap: round;
        transition: stroke-dasharray 0.3s linear;
    }
  
    .countdown-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 32px;
        font-weight: 700;
        color: #f59e0b;
    }
  
    /* PIN Not Received Section */
    .pin-not-received-section {
        padding: 10px 0;
    }
  
    .btn-whatsapp-help {
        width: 100%;
        padding: 18px;
        background: #25d366 !important;
        color: #fff !important;
        border: none;
        border-radius: 12px;
        font-size: 15px;
        font-weight: 600;
        text-decoration: none;
        display: block;
        text-align: center;
        transition: all 0.2s;
    }
  
    .btn-whatsapp-help:hover {
        background: #20ba5a !important;
        transform: scale(0.98);
        text-decoration: none;
        color: #fff !important;
    }
  
    /* Family Members List Styles */
    .family-members-list {
        margin-bottom: 20px;
    }
  
    .family-member-card {
        background: #f0fdf9;
        border: 2px solid #a7f3d0;
        border-radius: 12px;
        padding: 15px;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        animation: slideIn 0.3s ease;
    }
  
    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateX(-20px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
  
    .member-info {
        display: flex;
        align-items: flex-start;
        flex: 1;
        gap: 12px;
    }
  
    .member-number {
        background: #006400;
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 14px;
        flex-shrink: 0;
    }
  
    .member-details {
        flex: 1;
    }
  
    .member-name {
        font-size: 16px;
        font-weight: 700;
        color: #006400 !important;
        margin-bottom: 4px;
    }
  
    .member-meta {
        font-size: 13px;
        color: #059669;
        margin-bottom: 4px;
    }

    .member-parent {
        font-size: 12px;
        color: #0284c7;
        margin-bottom: 4px;
        padding: 4px 8px;
        background: #e0f2fe;
        border-radius: 6px;
        display: inline-block;
        margin-top: 4px;
    }

    .member-location {
        font-size: 12px;
        color: #6b7280;
    }
  
    .btn-remove-member {
        background: #fee2e2;
        color: #dc2626;
        border: none;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
  
    .btn-remove-member:hover {
        background: #dc2626;
        color: white;
    }
  
    /* Add Family Member Button */
    .btn-add-member {
        width: 100%;
        padding: 18px;
        background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%) !important;
        color: #fff !important;
        border: 2px dashed #0ea5e9;
        border-radius: 12px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
    }
  
    .btn-add-member:hover:not(:disabled) {
        background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%) !important;
        transform: scale(0.98);
        border-color: #0284c7;
    }
  
    .btn-add-member:disabled {
        background: #9ca3af !important;
        border-color: #9ca3af;
        cursor: not-allowed;
        opacity: 0.7;
    }

    /* Home Page Styles */
    .home-container {
        padding: 10px 0;
    }

    .registration-card {
        background: #ffffff;
        border: 2px solid #d1fae5;
        border-radius: 16px;
        padding: 20px;
        margin-bottom: 15px;
        box-shadow: 0 2px 8px rgba(0, 100, 0, 0.08);
    }

    .reg-header {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 2px solid #f0fdf4;
    }

    .reg-number {
        background: #006400;
        color: white;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 16px;
        flex-shrink: 0;
    }

    .reg-name {
        font-size: 18px;
        font-weight: 700;
        color: #006400;
        flex: 1;
    }

    .reg-details {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .reg-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
    }

    .reg-label {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
    }

    .reg-value {
        font-size: 14px;
        color: #1f2937;
        font-weight: 600;
        text-align: right;
    }

    .status-paid {
        color: #15803d !important;
        background: #dcfce7;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
    }

    .status-pending {
        color: #d97706 !important;
        background: #fef3c7;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
    }
  </style>